import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {formatDateAndTime} from "../../resources/constants";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import { setGeneralDetails, setLoginDetails} from "../../actions/actions";
import Header from "../common/header/header";
import PgSidebar from "../common/sidebar/pgsidebar";
import {Button} from "react-bootstrap";
function AcademicQualifications(props) {
    const [userData] = useState(props.applicationLogin);
    const navigate = useNavigate();
    const [selection, setSelection] = useState({
        ApplicationID: props.applicationData.EntryID,
        QualificationName: "",
        QualificationTitle: "",
        AwardingInstitution: "",
        GradeObtained: "",
        DateAwarded: "",
    });

    const [shouldSave, setShouldSave] = useState(false);

    const handleChange = (e) => {
        setSelection({ ...selection, [e.target.id]: e.target.value });
        setShouldSave(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        for (let value in selection) {
            if (selection.hasOwnProperty(value)) {
                if (selection[value] === "") {
                    toast.error(`${value} can't be empty`);
                    return false;
                }
            }
        }
        if (shouldSave) {
            toast.info(`Submitting... Please wait!`);
            await axios
                .post(`${serverLink}application/pg/qualification`, selection)
                .then((res) => {
                    if (res.data.message === "success") {
                        allApplicationData();
                        toast.success(`Qualification Submitted Successfully`);
                        // onNext();
                        onResetItem()
                    } else
                        toast.error(
                            `Something went wrong. Please check your connection and try again!`
                        );
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
        }
    };

    const onPrevious = () => {
        navigate("/postgraduate/personal-information");
    };

    const onNext = () => {
        navigate("/postgraduate/employment-details");
    };

    async function allApplicationData() {
        axios
            .get(
                `${serverLink}application/pg/application/data/${props.applicationData.EntryID}`
            )
            .then((response) => {
                props.setOnGeneralDetails(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const onResetItem = () => {
        setSelection({
            ApplicationID: props.applicationData.EntryID,
            QualificationName: "",
            QualificationTitle: "",
            AwardingInstitution: "",
            GradeObtained: "",
            DateAwarded: "",
        });
    }

    const deleteItem = async (id) => {
        if (id) {
            toast.info(`Deleting... Please wait!`);
            await axios
                .delete(`${serverLink}application/pg/qualification/delete/${id}`)
                .then((res) => {
                    if (res.data.message === "success") {
                        allApplicationData();
                        toast.success(`Deleted`);
                    } else {
                        toast.error(
                            `Something went wrong. Please check your connection and try again!`
                        );
                    }
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
        }
    }
    useEffect(() => {
        if (props.applicationLogin.length === 0) {
            navigate("/login");
        }
    }, [props.applicationLogin])
    return (
        // loading ?
        //     <Loader/>
        //     :
        <>
            <div className="main-wrapper">
                <Header/>
                <PgSidebar/>
                <div className="page-wrapper">
                    <div className="content">
                        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                                <div className="my-auto mb-2">
                                    <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                                    }</h3>
                                    <nav>
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <a href="">Dashboard</a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">Academic Qualifications</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-3">
                            <div className="row">
                                {/* Form Section */}
                                <div className="col-md-6 d-flex justify-content-center align-items-center min-vh-30">
                                    <div className="flex-fill">
                                        <br />
                                        <form className="login bg-white shadow p-5" onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <h5><b>Academic Qualifications</b></h5>
                                            </div>

                                            <div className="row gy-4">
                                                {/* Qualification Title */}
                                                <div className="col-sm-6">
                                                    <label htmlFor="QualificationTitle" className="form-label">
                                                        Qualification Title <span className="text-danger">*</span>
                                                    </label>
                                                    <select id="QualificationTitle" className="form-control" onChange={handleChange} value={selection.QualificationTitle}>
                                                        <option value="">Select Option</option>
                                                        <option value="MSc">MSc</option>
                                                        <option value="MBA">MBA</option>
                                                        <option value="PGD">PGD</option>
                                                        <option value="HND">HND</option>
                                                        <option value="BSc">BSc</option>
                                                        <option value="LLB">LLB</option>
                                                        <option value="NCE">NCE</option>
                                                    </select>
                                                </div>

                                                {/* Qualification Name */}
                                                <div className="col-sm-6">
                                                    <label htmlFor="QualificationName" className="form-label">
                                                        Qualification Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="QualificationName" className="form-control" onChange={handleChange} value={selection.QualificationName} />
                                                </div>

                                                {/* Awarding Institution */}
                                                <div className="col-sm-6">
                                                    <label htmlFor="AwardingInstitution" className="form-label">
                                                        Awarding Institution <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="AwardingInstitution" className="form-control" onChange={handleChange} value={selection.AwardingInstitution} />
                                                </div>

                                                {/* Grade Obtained */}
                                                <div className="col-sm-6">
                                                    <label htmlFor="GradeObtained" className="form-label">
                                                        Grade Obtained <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="GradeObtained" className="form-control" onChange={handleChange} value={selection.GradeObtained} />
                                                </div>

                                                {/* Date Obtained */}
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="DateAwarded" className="form-label">
                                                            Date Awarded <span className="text-danger">*</span>
                                                        </label>
                                                        <input type="date" id="DateAwarded" className="form-control" onChange={handleChange} value={selection.DateAwarded} />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Buttons */}
                                            <div className="col-md-12 mt-5">
                                                <div className="filters-group mb-lg-4 text-center">
                                                    <button className="btn btn-dark mx-2" onClick={onPrevious}>Previous</button>
                                                    <button className="btn btn-dark w-50 mx-2" type="submit">Save and Continue</button>
                                                    <button className="btn btn-dark mx-2" onClick={onNext}>Next</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                {/* Table Section */}
                                <div className="col-md-6 mt-4">
                                    <div className="bg-white shadow p-4">
                                        <h5 className="mb-3"><b>Qualifications Summary</b></h5>
                                        <table className="table table-bordered table-responsive">
                                            <thead>
                                            <tr>
                                                {/*<th>Title</th>*/}
                                                <th>Name</th>
                                                <th>Institution</th>
                                                {/*<th>Grade Obtained</th>*/}
                                                <th>Date Awarded</th>
                                                <th>Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {props.applicant_data?.qualification?.length > 0 &&
                                                props.applicant_data.qualification.map(
                                                    (item, index) => (
                                                        <tr key={index}>
                                                            {/*<td>{item.QualificationTitle}</td>*/}
                                                            <td>{item.QualificationName}</td>
                                                            <td>{item.AwardingInstitution}</td>
                                                            {/*<td>{item.GradeObtained}</td>*/}
                                                            <td>{formatDateAndTime(item.DateAwarded, "date")}</td>
                                                            <td><Button
                                                                variant="danger"
                                                                onClick={() =>
                                                                    deleteItem(item.EntryID)
                                                                }
                                                            >
                                                                <i
                                                                    className="fa fa-trash"
                                                                    style={{ fontsize: "30px" }}
                                                                />
                                                            </Button></td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<Footer/>*/}
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
        applicant_data: state.generalDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AcademicQualifications);
